import React from "react";

type HeadingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

interface ArticleHeadlineProps {
  title: string;
  isProContent?: boolean;
  size?: "small" | "medium" | "large";
  as?: HeadingLevel;
  className?: string;
  groupHover?: boolean;
}

const sizeClasses = {
  small: "text-accent-16",
  medium: "text-accent-16",
  large: "text-accent-26",
};

const ArticleHeadline = ({
  title,
  isProContent = false,
  size = "medium",
  as = "h3",
  className = "",
  groupHover = true,
}: ArticleHeadlineProps) => {
  const bgHoverColor = isProContent
    ? "group-hover:bg-pro-10"
    : "group-hover:bg-sifted-10";

  const baseClasses = `font-recklessBold ${sizeClasses[size]} leading-tight text-brand-neutral transition-colors`;
  const headingClasses = `${baseClasses} ${className}`.trim();

  const Heading = as as React.ElementType;

  return (
    <div className={`transition-colors ${bgHoverColor}`}>
      <Heading className={headingClasses}>{title}</Heading>
    </div>
  );
};

export default ArticleHeadline;
